import { setTituloPagina } from 'painel/actions';
import { Typography } from "@material-ui/core";
import { useDispatch } from 'react-redux';
import AppFooter from 'shared/template/AppFooter';
import history from '../history';
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useEffect } from 'react';
import { removeNotificationToken } from 'apps/notificacao/registroNotificacao';
import { openLogoutUrl } from 'platformImpl';

const useStyles = makeStyles(theme => ({
  content: {
    zIndex: "999",
    backgroundColor: '#fff',
    textAlign: 'justify',
    padding: '2rem 2rem 0',
    color: '#333333',
    display: 'block',
    height: '100%',
    overflow: 'auto',
    "-webkit-overflow-scrolling": 'touch',
    "-ms-overflow-style": 'none',
    "-ms-scroll-snap-type": 'mandatory',
    marginBottom: "45px"
  },
  title: {
    marginBottom: '1rem',
    fontSize: "20.16px",
    textAlign: "left",
    textTransform: "none"
  },
  subtitle: {
    marginBottom: '1rem',
    fontWeight: 'bold',
    textTransform: "none",
    textAlign: "left",
    fontSize: "1.2em"
  },
  paragrafo: {
    marginBottom: '1rem'
  },
}));


const PoliticaPrivacidade = props => {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  useEffect(() => {
      dispatch(setTituloPagina("Política de Privacidade do Meu INSS"))
  }, [dispatch]);

  const logout = () => {
    localStorage.removeItem('ifs_auth');
    localStorage.removeItem('ifs_ts');
    sessionStorage.removeItem('initTrack');
    removeNotificationToken();
    openLogoutUrl();
  }

  return (<>
    <div className={classes.content}> 
      <Typography variant='h2' className={classes.title}>
        Política de Privacidade do Meu INSS
      </Typography>
      <Typography variant='h3' className={classes.subtitle}>
        Produto e Serviço
      </Typography>
      <Typography className={classes.paragrafo}>
        O aplicativo Meu INSS tem por objetivo facilitar o seu acesso aos benefícios e serviços prestados pelo INSS com clareza e transparência nas informações, segurança e privacidade.
      </Typography>
      <Typography className={classes.paragrafo}>
        Pensando nisso, detalhamos abaixo nosso compromisso e respeito com a proteção e privacidade dos seus dados pessoais.
      </Typography>
      <Typography variant='h3' className={classes.subtitle}>
        Por que coletamos seus dados pessoais
      </Typography>
      <Typography className={classes.paragrafo}>
        Seus dados pessoais são utilizados somente quando necessário, pelo tempo que for preciso e para viabilizar a prestação de um serviço solicitado.
      </Typography>
      <Typography className={classes.paragrafo} component={'span'} variant={'body2'}>
        Eles são úteis para:
        <ul>
          <li>Permitir a prestação dos serviços;</li>
          <li>Possibilitar o exercício dos seus direitos sobre seus dados;</li>
          <li>Personalizar a experiência de uso;</li>
          <li>Analisar e aperfeiçoar os serviços fornecidos;</li>
          <li>Respeitar exigências legais;</li>
          <li>Promover a cidadania e políticas de utilidade pública;</li>
          <li>Garantir a segurança e prevenir atividades ilegais.</li>
        </ul>
      </Typography>
      <Typography variant='h3' className={classes.subtitle}>
        Quais dados são coletados e para qual finalidade
      </Typography>
      <Typography className={classes.paragrafo}>
        Abaixo, você verá quais dados são coletados pelo Meu INSS e como eles podem ser coletados:
      </Typography>
      <Typography variant='h3' className={classes.subtitle}>
        Dados cadastrais serviço gov.br
      </Typography>
      <Typography className={classes.paragrafo} component={'span'} variant={'body2'}>
        Para você ser identificado de forma segura e ter acesso aos serviços do Meu INSS, é utilizado o serviço Acesso.gov.br, que coleta os seguintes dados:
        <ul>
          <li>Nome completo</li>
          <li>Telefone</li>
          <li>E-mail</li>
          <li>CPF</li>
          <li>Endereço</li>
          <li>Data de nascimento</li>
        </ul>
      </Typography>
      <Typography variant='h3' className={classes.subtitle}>
        Dados pessoais fornecidos pelo titular
      </Typography>
      <Typography className={classes.paragrafo}>
        Solicitaremos e faremos uso apenas dos dados que são imprescindíveis e necessários para executar o serviço solicitado, e de acordo com a finalidade de cada serviço.
      </Typography>
      <Typography className={classes.paragrafo}>
        Sendo assim, o Meu INSS poderá solicitar acesso ao seus dados dos sistemas do Instituto Nacional do Seguro Social (INSS) e da Receita Federal do Brasil (RFB)
      </Typography>
      <Typography className={classes.paragrafo} component={'span'} variant={'body2'}>
        Dados dos sistemas do INSS que podem ser utilizados:
        <ul>
          <li>Registros Previdenciários</li>
          <li>Nome Completo</li>
          <li>NIT</li>
          <li>Nome Social</li>
          <li>Data de nascimento</li>
          <li>Sexo</li>
          <li>Filiação</li>
          <li>Nacionalidade</li>
          <li>Naturalidade</li>
          <li>Informações sobre registro de Óbito</li>
          <li>Data de óbito, quando cabível</li>
          <li>Histórico de solicitações de Serviços ao INSS</li>
          <li>Informações Médico Periciais</li>
          <li>Informações financeiras (dados bancários, como número de conta e valores pagos pelo INSS)</li>
        </ul>
      </Typography>
      <Typography className={classes.paragrafo} component={'span'} variant={'body2'}>
        Dados da RFB que podem ser utilizados para conferir a integridade dos dados entre as bases do governo:
        <ul>
          <li>CPF</li>
          <li>Nome completo</li>
          <li>Nome da mãe</li>
          <li>Data de Nascimento</li>
        </ul>
      </Typography>
      <Typography variant='h3' className={classes.subtitle}>
        Dados coletados automaticamente pelo dispositivo
      </Typography>
      <Typography className={classes.paragrafo} component={'span'} variant={'body2'}>
        Para aprimorar a usabilidade e navegabilidade do aplicativo, informações não pessoais podem ser coletadas automaticamente pelo dispositivo eletrônico utilizado (celular ou computador), pelo navegador ou por meio de cookies ou outras ferramentas já instaladas no dispositivo do usuário. São elas:
        <ul>
          <li>Modelo de hardware do dispositivo eletrônico utilizado pelo usuário;</li>
          <li>Sistema operacional e versão utilizados;</li>
          <li>Tipo de navegador e versão utilizada;</li>
          <li>Identificadores de dispositivos;</li>
          <li>Informações sobre a rede utilizada e o número de telefone;</li>
          <li>Idioma utilizado no dispositivo ou navegador;</li>
          <li>Resolução de tela;</li>
          <li>Identificadores exclusivos do aplicativo;</li>
          <li>Endereço de Protocolo de Internet (Endereço IP);</li>
          <li>Localização geográfica (geolocalização);</li>
          <li>Duração do acesso;</li>
          <li>Informações de identificador de SMS;</li>
          <li>Páginas visualizadas dentro do site;</li>
          <li>Forma de utilização do aplicativo;</li>
        </ul>
      </Typography>
      <Typography variant='h3' className={classes.subtitle}>
        Como os dados são armazenados
      </Typography>
      <Typography className={classes.paragrafo} component={'span'} variant={'body2'}>
        <div>Todos os dados coletados são armazenados, pelo tempo necessário, em centros de dados sob a gestão da Administração Pública Federal.</div>
        <div>As informações trafegam de modo criptografado entre o seu dispositivo e os demais equipamentos que se integram à solução com medidas que assegurem a confidencialidade, integridade, autenticidade e inviolabilidade dos seus dados.</div>
      </Typography>
      <Typography className={classes.paragrafo}>
        A partir do momento que seus dados não tiverem mais utilidade ou o titular dos dados solicitar sua eliminação, eles serão automaticamente eliminados para prevenir a proteção da sua privacidade.
      </Typography>
      <Typography className={classes.paragrafo}>
        Ainda assim, seus dados pessoais poderão ser mantidos para cumprimento de obrigação legal ou regulatória.
      </Typography>
      <Typography variant='h3' className={classes.subtitle}>
        Compartilhamento de informações com Terceiros
      </Typography>
      <Typography className={classes.paragrafo}>
        Seus dados de caráter pessoal não serão repassados a terceiros, nem pela Dataprev, empresa pública da União, nem pela Administração Pública Federal.
      </Typography>
      <Typography className={classes.paragrafo}>
        Todo e qualquer dado pessoal só poderá ser repassado mediante sua autorização, exceto quando exigido por lei.
      </Typography>
      <Typography variant='h3' className={classes.subtitle}>
        Cookies
      </Typography>
      <Typography className={classes.paragrafo}>
        Nós usamos cookies quando você interage com o Meu INSS via navegador. Os dados de cookies de sessão são excluídos assim que você deixa o Meu INSS. Outros dados de cookies são armazenados para facilitar seu acesso, reconhecendo você ao retornar para o Meu INSS.
      </Typography>
      <Typography className={classes.paragrafo}>
        Seu consentimento quanto à utilização dos cookies pode a qualquer momento ser alterado e, inclusive, recusado. É importante saber que, ao retirar o consentimento de utilização de cookies, o funcionamento de determinadas funcionalidades estarão indisponíveis prejudicando uma melhor experiência com a aplicação.
      </Typography>
      <Typography variant='h3' className={classes.subtitle}>
        Retenção das informações coletadas
      </Typography>
      <Typography className={classes.paragrafo}>
        A partir do momento que seus dados não tiverem mais utilidade ou o titular dos dados solicitar sua eliminação, eles serão automaticamente eliminados para prevenir a proteção da sua privacidade.
      </Typography>
      <Typography className={classes.paragrafo}>
        Ainda assim, seus dados pessoais poderão ser mantidos para cumprimento de obrigação legal ou regulatória.
      </Typography>
      <Typography variant='h3' className={classes.subtitle}>
        Atualização da Política e Consentimento
      </Typography>
      <Typography className={classes.paragrafo}>
        Para estar de acordo com a Lei Geral de Proteção de Dados(LGPD), seus dados serão coletados, armazenados e tratados apenas com o seu consentimento.
      </Typography>
      <Typography className={classes.paragrafo}>
        É importante estar claro que, caso não aprove ou cancele um consentimento para utilização dos seus dados pessoais, isto poderá impossibilitar o funcionamento adequado de uma funcionalidade ou a execução de um serviço que dependa destes dados.
      </Typography>
      <Typography>
        Ao fornecer seus dados pessoais para utilização do Meu INSS você estará de acordo com o conteúdo desta Política de Privacidade.
      </Typography>
      <Typography>
        Esta política pode ser alterada a qualquer momento para atender à evolução do aplicativo ou à Lei Geral de Proteção de Dados (LGPD) <a href='http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/L13709.htm'>(Veja aqui a lei)</a>. Por isso, recomendamos que volte a ler este termo daqui a um tempo.
      </Typography>
      <br/><br/>
    </div>

    <AppFooter 
        primaryText="Aceitar" 
        primaryAction={() => history.push('/')} 
        secondaryAction={() => {
          if (navigator.app) { 
            navigator.app.exitApp()
          }else {
            logout();
          };
        }} 
        secondaryText="Sair" 
      />
    </>
  )
}

export default PoliticaPrivacidade;
